import React, { useCallback, useEffect, useMemo } from 'react';
import { CustomSettingsContextProvider } from '../../../../../CustomSettings/Services/CustomSettingsContext';
import { CustomSettingKey } from '../../../../../Base/Enums/CustomSettingKey.enum';
import ManagerInsuranceCompaniesBatchesList from '../ManagerInsuranceCompaniesBatchesList/ManagerInsuranceCompaniesBatchesList';
import { useInsuranceCompanyBatchesQuery } from '../../../../../../graphql/graphql';
import { useFlatDataList } from '../../../../../Base/Hooks/useFlatDataList';
import {
	InsuranceCompanyBatch,
	InsuranceCompanyBatchesTable,
	InvoiceBatch,
} from '../../../../Consts/InsuranceCompanyBatchesDefaultColumns.const';
import ManagerInsuranceCompaniesBatchesMenu from '../ManagerInsuranceCompaniesBatchesMenu/ManagerInsuranceCompaniesBatchesMenu';

const ManagerInsuranceCompaniesBatches = () => {
	const { pagination, flatData, appendData, getNextPage, updateItem, reset } =
		useFlatDataList<InsuranceCompanyBatch>();
	const { data, isLoading, refetch } = useInsuranceCompanyBatchesQuery({
		pagination,
	});

	const reloadData = useCallback(() => {
		reset();

		if (pagination.skip === 0) {
			refetch();
		}
	}, [pagination.skip, reset, refetch]);

	useEffect(() => {
		appendData(data?.insuranceCompanyBatches?.data ?? []);
	}, [data]);

	const table: InsuranceCompanyBatchesTable = useMemo(
		() => ({
			onInvoiceCreated: (batchId: string, invoiceBatch: InvoiceBatch) => {
				const batch = flatData.find(item => item.id === batchId);
				if (!batch) return;

				updateItem({
					...batch,
					childInvoiceBatch: {
						id: invoiceBatch.id,
						dcid: invoiceBatch.dcid,
						batchStatus: invoiceBatch.batchStatus,
						file: invoiceBatch.file,
					},
				});
			},
		}),
		[flatData, updateItem],
	);

	return (
		<CustomSettingsContextProvider
			customSettingsKey={CustomSettingKey.INSURANCE_COMPANIES_BATCHES}>
			<ManagerInsuranceCompaniesBatchesMenu reloadData={reloadData} />
			<ManagerInsuranceCompaniesBatchesList
				data={flatData}
				onLoadMore={getNextPage}
				onRefresh={reloadData}
				isLoading={isLoading}
				hasMoreData={Boolean(data?.insuranceCompanyBatches?.meta?.hasNextPage)}
				table={table}
			/>
		</CustomSettingsContextProvider>
	);
};

export default ManagerInsuranceCompaniesBatches;
